import { Typography, Box } from '@mui/material';
import Term from '../../../assets/images/terms/terms.png';

const T = ({ children, ...rest }) => (
    <Typography sx={{ fontFamily: '"Inter", sans-serif' }} variant="body1" {...rest}>{children}</Typography>
);
const H5 = ({ children }) => (
    <Typography sx={{ fontFamily: '"DM Sans", sans-serif' }} fontWeight="bold" variant="h5">{children}</Typography>
);
const H6 = ({ children }) => (
    <Typography sx={{ fontFamily: '"DM Sans", sans-serif' }} fontWeight="bold" variant="h6">{children}</Typography>
);

export const orbitStoreTermsContext = () => [
    [
        {
            data: (
                <Box>
                    <Box style={{ textAlign: 'center' }}><img src={Term} alt="store terms" width="250" /></Box>
                    <br /><br />
                    <H5>ORBIT STORE – STORE TERMS OF SALE</H5>
                    <br /><br />
                    <T>
                        Effective Date: September 10, 2026
                        <br />Last Updated: September 10, 2026
                        <br /><br />
                        These Store Terms of Sale (“Terms”) govern purchases, subscriptions, licenses, and other paid transactions made through the Orbit Store using POFPay or another authorized payment facility.
                        <br /><br />
                        By selecting “Buy,” “Subscribe,” “Pay,” “Confirm Payment,” or a similar button, you agree to these Terms, together with the applicable product or subscription details displayed before checkout.
                    </T>
                    <br /><br /><br />

                    <H6>1. About Orbit Store and POFPay</H6>
                    <T>
                        <br />Orbit Store is a digital marketplace through which users may discover, purchase, subscribe to, or obtain licenses to software applications, digital tools, systems, and related services (“Tools”).
                        <br /><br />POFPay is the payment interface used by Orbit Store to facilitate payment transactions. Payment processing may be performed through authorized third-party payment service providers.
                        <br /><br />The actual seller, developer, publisher, or service provider responsible for a Tool may be POFSIS, an affiliated entity, or a third-party accredited Tool Developer, as identified on the applicable product page, subscription page, invoice, receipt, or order confirmation.
                    </T>
                    <br /><br /><br />

                    <H6>2. Acceptance of Terms</H6>
                    <T>
                        <br />By completing a purchase through Orbit Store, you confirm that:
                        <br /><br />• the information you provide is accurate and complete;
                        <br />• you are authorized to use the selected payment method;
                        <br />• you have reviewed the Tool description, features, price, subscription period, and other applicable conditions;
                        <br />• you agree to these Store Terms of Sale and other applicable Orbit Store policies.
                        <br /><br />If you are purchasing on behalf of a company or organization, you confirm that you are authorized to bind that organization to these Terms.
                    </T>
                    <br /><br /><br />

                    <H6>3. Digital License and Right to Use</H6>
                    <T>
                        <br />Unless specifically stated otherwise, purchasing a Tool does not transfer ownership of the software, source code, intellectual property, trademarks, or other proprietary rights.
                        <br /><br />Your purchase generally provides you with a limited, non-exclusive, non-transferable, and revocable right or license to use the Tool according to:
                        <br /><br />• the subscription or license purchased;
                        <br />• the number of authorized users;
                        <br />• the applicable Tool terms;
                        <br />• the developer&apos;s license conditions; and
                        <br />• Orbit Store policies.
                        <br /><br />You may not copy, resell, redistribute, sublicense, reverse engineer, improperly modify, or commercially exploit a Tool except where expressly permitted by the Tool owner or applicable law.
                    </T>
                    <br /><br /><br />

                    <H6>4. Prices</H6>
                    <T>
                        <br />The price displayed during checkout is the price applicable to the transaction at the time the order is submitted, subject to correction of obvious pricing or system errors.
                        <br /><br />Prices may vary depending on:
                        <br /><br />• subscription plan;
                        <br />• number of users;
                        <br />• selected features;
                        <br />• transaction volume;
                        <br />• usage;
                        <br />• add-ons;
                        <br />• implementation requirements;
                        <br />• applicable taxes; or
                        <br />• other pricing arrangements displayed for the Tool.
                        <br /><br />Orbit Store and Tool Developers may change future pricing. Changes will not ordinarily affect transactions already completed, except for future subscription renewals where proper notice is provided.
                    </T>
                    <br /><br /><br />

                    <H6>5. Taxes and Other Charges</H6>
                    <T>
                        <br />Applicable taxes, government charges, payment processing charges, or other fees may be included in or added to the price, depending on the transaction and applicable law.
                        <br /><br />Any applicable VAT or similar tax will be reflected in the invoice, official receipt, billing statement, or payment summary where required.
                        <br /><br />Business customers remain responsible for any tax obligations specifically imposed upon them by applicable law.
                    </T>
                    <br /><br /><br />

                    <H6>6. Payment</H6>
                    <T>
                        <br />Payments through POFPay may be processed using authorized payment channels or third-party payment providers.
                        <br /><br />By submitting payment, you authorize the applicable amount to be charged to your selected payment method.
                        <br /><br />A transaction is considered completed only after successful payment confirmation.
                        <br /><br />Orbit Store may reject, cancel, or place a transaction on hold where necessary due to:
                        <br /><br />• payment failure;
                        <br />• suspected fraud;
                        <br />• unauthorized payment activity;
                        <br />• incorrect pricing;
                        <br />• technical error;
                        <br />• violation of these Terms; or
                        <br />• legal or regulatory requirements.
                    </T>
                    <br /><br /><br />

                    <H6>7. Order Confirmation and Receipt</H6>
                    <T>
                        <br />After a successful transaction, you may receive an electronic confirmation containing information such as:
                        <br /><br />• Tool or App name;
                        <br />• subscription or license purchased;
                        <br />• amount paid;
                        <br />• transaction date;
                        <br />• payment reference;
                        <br />• seller or developer information, where applicable; and
                        <br />• receipt, invoice, or billing information.
                        <br /><br />Users should retain their payment confirmation and transaction reference for future support requests.
                    </T>
                    <br /><br /><br />

                    <H6>8. Tool Activation and Access</H6>
                    <T>
                        <br />Access to a purchased Tool may be:
                        <br /><br />• activated immediately;
                        <br />• activated after account verification;
                        <br />• activated after company or user setup;
                        <br />• activated after developer approval; or
                        <br />• subject to an implementation or onboarding process.
                        <br /><br />The applicable activation process should be stated on the Tool&apos;s product or subscription page.
                        <br /><br />The purchaser is responsible for providing accurate information necessary to activate the Tool.
                    </T>
                    <br /><br /><br />

                    <H6>9. Subscriptions and Renewals</H6>
                    <T>
                        <br />For subscription-based Tools, the applicable billing period will be displayed before purchase, such as:
                        <br /><br />Monthly, Quarterly, Annual, Usage-Based, Per User, Per Company, or another specified billing period.
                        <br /><br />Where automatic renewal applies, this must be disclosed before purchase.
                        <br /><br />Unless otherwise stated, a recurring subscription will continue until cancelled in accordance with the applicable subscription conditions.
                        <br /><br />Any price change applicable to a future renewal should be communicated before the new price becomes effective where required.
                    </T>
                    <br /><br /><br />

                    <H6>10. Cancellation</H6>
                    <T>
                        <br />Users may cancel a recurring subscription through the available account, subscription-management, or support process.
                        <br /><br />Cancellation normally prevents future renewals but does not automatically refund amounts already paid for the current billing period.
                        <br /><br />Access may continue until the end of the paid subscription period unless otherwise stated.
                    </T>
                    <br /><br /><br />

                    <H6>11. Refunds</H6>
                    <T>
                        <br />Because many Orbit Store products are digital products or software subscriptions that may be activated immediately, purchases are generally considered final once access has been successfully provided.
                        <br /><br />However, a refund, credit, correction, or replacement may be considered when:
                        <br /><br />• the user was charged more than once for the same transaction;
                        <br />• payment was successfully collected but the purchased Tool was not made available;
                        <br />• an incorrect amount was charged due to a verified system error;
                        <br />• the seller or developer approves the refund;
                        <br />• the transaction qualifies under the Tool&apos;s specific refund policy; or
                        <br />• a refund or remedy is required under applicable law.
                        <br /><br />Refund requests should include the transaction reference and supporting information.
                        <br /><br />Nothing in these Terms is intended to remove or restrict rights that cannot legally be waived under applicable consumer protection laws.
                    </T>
                    <br /><br /><br />

                    <H6>12. Third-Party Developer Tools</H6>
                    <T>
                        <br />Some Tools available in Orbit Store may be developed and provided by independent third-party developers.
                        <br /><br />Where a third-party developer is identified as the seller or service provider, that developer is primarily responsible for matters relating to its Tool, including:
                        <br /><br />• functionality;
                        <br />• product descriptions;
                        <br />• service delivery;
                        <br />• technical support;
                        <br />• maintenance;
                        <br />• updates;
                        <br />• warranties or commitments expressly offered;
                        <br />• licensing conditions; and
                        <br />• compliance with applicable requirements.
                        <br /><br />Orbit Store may assist in coordinating concerns between users and accredited developers but does not automatically assume responsibility for commitments independently made by a third-party developer.
                    </T>
                    <br /><br /><br />

                    <H6>13. Beta, Trial, or Pre-Release Tools</H6>
                    <T>
                        <br />Certain Tools may be identified as Beta, Trial, Pilot, Early Access, Preview, or Pre-Release.
                        <br /><br />These Tools may still contain incomplete features, limitations, bugs, or functionality subject to change.
                        <br /><br />Where a user knowingly participates in beta testing, the applicable beta-testing, confidentiality, feedback, UAT, or evaluation conditions may apply in addition to these Terms.
                        <br /><br />Beta or pre-release status should be clearly disclosed before purchase or activation.
                    </T>
                    <br /><br /><br />

                    <H6>14. Tool Changes and Updates</H6>
                    <T>
                        <br />Developers may periodically update Tools to improve:
                        <br /><br />• functionality;
                        <br />• security;
                        <br />• usability;
                        <br />• system compatibility;
                        <br />• compliance; or
                        <br />• performance.
                        <br /><br />Features may be modified where reasonably necessary, provided that material changes affecting a paid subscription are handled in accordance with applicable agreements and law.
                    </T>
                    <br /><br /><br />

                    <H6>15. User Responsibilities</H6>
                    <T>
                        <br />Users must use Tools lawfully and responsibly.
                        <br /><br />Users must not:
                        <br /><br />• attempt unauthorized access;
                        <br />• interfere with system security;
                        <br />• misuse another user&apos;s account;
                        <br />• introduce malicious software;
                        <br />• circumvent usage limits or payment controls;
                        <br />• use the Tool for unlawful purposes; or
                        <br />• violate intellectual property rights.
                        <br /><br />Users are responsible for maintaining the confidentiality of their usernames, passwords, and account credentials.
                    </T>
                    <br /><br /><br />

                    <H6>16. Availability and Maintenance</H6>
                    <T>
                        <br />Orbit Store, POFPay, and the Tools may occasionally be unavailable because of:
                        <br /><br />• scheduled maintenance;
                        <br />• system upgrades;
                        <br />• internet or infrastructure interruptions;
                        <br />• third-party service outages;
                        <br />• cybersecurity events;
                        <br />• emergency maintenance; or
                        <br />• circumstances beyond reasonable control.
                        <br /><br />Reasonable efforts will be made to restore affected services as soon as practicable.
                    </T>
                    <br /><br /><br />

                    <H6>17. Product Descriptions</H6>
                    <T>
                        <br />Orbit Store and Tool Developers aim to provide accurate information regarding Tool features, compatibility, pricing, and availability.
                        <br /><br />Minor differences between descriptions, screenshots, mockups, previews, prototypes, and the final product may occur.
                        <br /><br />Material functionality should be determined based on the actual plan, proposal, service agreement, subscription description, or Tool specifications applicable to the purchase.
                    </T>
                    <br /><br /><br />

                    <H6>18. Intellectual Property</H6>
                    <T>
                        <br />All trademarks, software, designs, interfaces, documentation, content, source code, systems, logos, and other intellectual property remain the property of their respective owners.
                        <br /><br />Purchase of a Tool grants only the rights expressly provided under the applicable license or subscription.
                    </T>
                    <br /><br /><br />

                    <H6>19. Privacy and Personal Information</H6>
                    <T>
                        <br />Personal information collected in connection with purchases, account registration, payments, subscriptions, and support will be handled according to the applicable Privacy Policy and data protection requirements.
                        <br /><br />Payment information may also be processed by authorized third-party payment providers under their respective privacy and security policies.
                    </T>
                    <br /><br /><br />

                    <H6>20. Fraud and Unauthorized Transactions</H6>
                    <T>
                        <br />Orbit Store and POFPay may implement security and fraud-prevention measures.
                        <br /><br />Transactions may be reviewed, suspended, rejected, or cancelled if there is reasonable basis to suspect:
                        <br /><br />• fraud;
                        <br />• unauthorized payment;
                        <br />• identity misuse;
                        <br />• payment abuse;
                        <br />• violation of these Terms; or
                        <br />• other unlawful activity.
                    </T>
                    <br /><br /><br />

                    <H6>21. Suspension or Termination</H6>
                    <T>
                        <br />Access to a Tool or Orbit Store account may be suspended or terminated for serious or repeated violations of:
                        <br /><br />• these Terms;
                        <br />• the Tool&apos;s license agreement;
                        <br />• payment obligations;
                        <br />• security requirements; or
                        <br />• applicable laws.
                        <br /><br />Where reasonably possible, the affected user will be informed of the reason and any available corrective action.
                    </T>
                    <br /><br /><br />

                    <H6>22. Limitation of Liability</H6>
                    <T>
                        <br />To the extent permitted by applicable law, Orbit Store, POFPay, POFSIS, and participating Tool Developers will not be responsible for indirect, incidental, special, or consequential losses arising solely from the use or inability to use a Tool.
                        <br /><br />Nothing in these Terms excludes liability that cannot legally be excluded or limited.
                        <br /><br />Where a separate signed agreement, service-level agreement, proposal, or enterprise contract applies, the liability provisions of that agreement will take precedence where they conflict with these Terms.
                    </T>
                    <br /><br /><br />

                    <H6>23. Enterprise and Customized Agreements</H6>
                    <T>
                        <br />Some purchases may be governed by a separate:
                        <br /><br />• Subscription Agreement;
                        <br />• Software License Agreement;
                        <br />• Service Agreement;
                        <br />• Enterprise Agreement;
                        <br />• Statement of Work;
                        <br />• Proposal;
                        <br />• Data Processing Agreement; or
                        <br />• Service-Level Agreement.
                        <br /><br />If there is a conflict between these Store Terms and a separately signed agreement for the same service, the signed agreement will generally prevail for the matters it specifically covers.
                    </T>
                    <br /><br /><br />

                    <H6>24. Changes to These Terms</H6>
                    <T>
                        <br />Orbit Store may update these Terms from time to time to reflect changes in:
                        <br /><br />• products and services;
                        <br />• payment processes;
                        <br />• business arrangements;
                        <br />• laws or regulations; or
                        <br />• marketplace policies.
                        <br /><br />The effective or last-updated date will be shown at the beginning of these Terms.
                        <br /><br />Material changes affecting existing subscriptions will be communicated where appropriate or legally required.
                    </T>
                    <br /><br /><br />

                    <H6>25. Governing Law</H6>
                    <T>
                        <br />These Terms shall be governed by the laws of the Republic of the Philippines, without prejudice to any mandatory consumer rights or other protections available under applicable law.
                        <br /><br />The parties are encouraged to first attempt to resolve disputes through good-faith communication before pursuing other available remedies.
                    </T>
                    <br /><br /><br />

                    <H6>26. Contact and Support</H6>
                    <T>
                        <br />For questions regarding purchases, billing, subscriptions, refunds, or transaction concerns, please contact:
                        <br /><br />Orbit Store / POFPay Support
                        <br />Email: [support@yourdomain.com]
                        <br />Website: [Insert Website]
                        <br />Business Name: [Insert Registered Legal Entity]
                        <br />Business Address: [Insert Registered Address]
                        <br /><br />When contacting support regarding a transaction, please provide your Payment Reference or Order Number whenever possible.
                    </T>
                    <br /><br />
                </Box>
            ),
        },
    ],
];
